module.exports = __webpack_public_path__ + "static/no-99daecda995a1d8639c8d1f2c04c77bb.png";